import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["errorHandler"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import getHOCDisplayName from "../service/getHOCDisplayName";
import ErrorContext from "../service/ErrorContext";
import withErrorManager, { withErrorManagerPropTypes } from "./withErrorManager";
var withErrorProvider = function withErrorProvider(WrappedComponent) {
  var autoErrorRendering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var loggerName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var ErrorProvider = function ErrorProvider(_ref) {
    var errorHandler = _ref.errorHandler,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(ErrorContext.Provider, {
      value: errorHandler
    }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      errorHandler: errorHandler
    }, restProps)));
  };
  ErrorProvider.propTypes = _objectSpread({}, withErrorManagerPropTypes);
  return compose(setDisplayName(getHOCDisplayName(WrappedComponent, 'withErrorProvider')), withErrorManager(autoErrorRendering, loggerName))(ErrorProvider);
};
export default withErrorProvider;
export var withErrorProviderPropTypes = withErrorManagerPropTypes;